document.addEventListener("DOMContentLoaded", () => {
  const poisContainer = document.getElementById("pois");
  if (!poisContainer) {
    return;
  }

  const url = poisContainer.dataset.url;
  if (!url) {
    return;
  }

  let translations = {};
  try {
    translations = JSON.parse(poisContainer.dataset.translations || "{}");
  } catch (e) {
    translations = {};
  }

  const roundDistance = (distance) => {
    if (distance < 10) return distance;
    if (distance < 10000) return Math.round(distance / 100) * 100;
    return Math.floor(distance / 1000) * 1000;
  };

  const formatDistance = (distance) => {
    if (distance === 0) {
      return translations["rental.pois.nearby"] || "nebenan";
    } else if (distance < 1000) {
      return `${distance} m`;
    } else {
      const km = (distance / 1000).toLocaleString(
        document.documentElement.lang || "de",
        {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        }
      );
      return `${km} km`;
    }
  };

  const renderPois = (pois) => {
    pois.forEach((poiGroup) => {
      if (
        ["bus_stop", "public_transportation_station"].includes(poiGroup.type)
      ) {
        return;
      }

      const col = poisContainer.querySelector(`[data-type="${poiGroup.type}"]`);
      if (!col) return;

      const poiInfoList = col.querySelectorAll(".poi-info");
      poiInfoList.forEach((el, index) => {
        el.classList.remove("animate-pulse");
        const item = poiGroup.data && poiGroup.data[index];
        if (!item) {
          el.innerHTML = '<span class="text-gray-400">–</span>';
        } else {
          el.innerHTML = `
            <span class="flex justify-between items-baseline gap-2 w-full">
              <span class="truncate" title="${item.name}">${item.name}</span>
              <span class="text-right whitespace-nowrap text-brandcopy-500 text-xs">${formatDistance(roundDistance(item.distance))}</span>
            </span>
          `;
        }
      });
    });

    // Handle public_transport (combines bus_stop and public_transportation_station)
    const ptCol = poisContainer.querySelector('[data-type="public_transport"]');
    if (ptCol) {
      const ptInfoList = ptCol.querySelectorAll(".poi-info");
      const busData = pois.find((p) => p.type === "bus_stop");
      const trainData = pois.find(
        (p) => p.type === "public_transportation_station"
      );

      const busItem = busData && busData.data && busData.data[0];
      const trainItem = trainData && trainData.data && trainData.data[0];

      if (ptInfoList[0]) {
        ptInfoList[0].classList.remove("animate-pulse");
        if (!busItem) {
          ptInfoList[0].innerHTML = '<span class="text-gray-400">–</span>';
        } else {
          const busLabel = translations["rental.pois.bus"] || "Bus";
          ptInfoList[0].innerHTML = `
            <span class="flex justify-between items-baseline gap-2 w-full">
              <span class="text-xs text-brandcopy-500 mr-1 font-medium">${busLabel}</span>
              <span class="truncate flex-1" title="${busItem.name}">${busItem.name}</span>
              <span class="text-right whitespace-nowrap text-brandcopy-500 text-xs">${formatDistance(roundDistance(busItem.distance))}</span>
            </span>
          `;
        }
      }

      if (ptInfoList[1]) {
        ptInfoList[1].classList.remove("animate-pulse");
        if (!trainItem) {
          ptInfoList[1].innerHTML = '<span class="text-gray-400">–</span>';
        } else {
          const trainLabel = translations["rental.pois.train"] || "Bahn";
          ptInfoList[1].innerHTML = `
            <span class="flex justify-between items-baseline gap-2 w-full">
              <span class="text-xs text-brandcopy-500 mr-1 font-medium">${trainLabel}</span>
              <span class="truncate flex-1" title="${trainItem.name}">${trainItem.name}</span>
              <span class="text-right whitespace-nowrap text-brandcopy-500 text-xs">${formatDistance(roundDistance(trainItem.distance))}</span>
            </span>
          `;
        }
      }
    }
  };

  fetch(url, {
    method: "GET",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Accept: "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) throw new Error("POI fetch error");
      return response.json();
    })
    .then((data) => renderPois(data))
    .catch(() => {
      // Clear skeleton pulse on error
      poisContainer.querySelectorAll(".poi-info").forEach((el) => {
        el.classList.remove("animate-pulse");
        el.innerHTML = '<span class="text-gray-400">–</span>';
      });
    });
});
